import { AgregationService, BundleCall } from '@ispm-client/modules/aggregator/services';
import { Findings, SegmentAnnotationBindings, SegmentDefinition } from '@ispm-client/modules/segments/interfaces';
import { get, isEmpty, filter as lodashFilter, isEqual, differenceWith, remove,cloneDeep, maxBy } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs/Rx';
import { IdataBinding } from '@ispm-client/modules/aggregator/interfaces';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StringUtils } from '@ispm/shared/utils/String.utils';
import {catchError, map, share, retry} from "rxjs/operators";
import {ConfigurationStoreHandler} from "../../../app/configuration/services/configuration-store-handler.service";
import {EMPTY} from "rxjs/index";
import { take, tap } from 'rxjs/operators';
import {ConfirmModalLoaderPayload} from "@ispm/layout/classes/confirm-modal-loader-payload";
import {ModalLoaderNgjsService} from "@ispm/layout/services/modal-loader-ngjs.service";
import {NavigationConfigService} from "@ispm/navigation/services/navigationConfig.service";
import {Router} from "@angular/router";

@Injectable()
export class SegmentService {

  segmentDef: SegmentDefinition;
  private cached: Map<string, string> = new Map();
  subscribeList: Map<string, BehaviorSubject<any>> = new Map<string, BehaviorSubject<any>>();
  imageContent: Map<string, Observable<string>> = new Map<string, Observable<string>>();
  imgDirectoryPath = '/assets/ispm/images/';

  constructor(private _ispmHttpClient: IspmHttpClient,
              private _bundleCall: BundleCall,
              private _agregatorService: AgregationService,
              private http: HttpClient,
              private _router: Router,
              private _modalLoader: ModalLoaderNgjsService,
              private _configurationStoreHandler: ConfigurationStoreHandler,
              private _navigationConfigService: NavigationConfigService
  ) {

  }

  /**
   * Register new observable
   * @param name
   * @returns {Observable<any>}
   */
  registerObservable(name): Observable<Findings> {
    if (!this.subscribeList.has(name)) {
      const observable = <BehaviorSubject<Findings>> new BehaviorSubject(null);
      this.subscribeList.set(name, observable);
      return observable.asObservable() as Observable<any>;
    } else {
      return this.subscribeList.get(name).asObservable() as Observable<Findings>;
    }
  }

  /**
   * returning the observable of the popup
   * optional - register an observable if not found
   *
   * @param {string} name
   * @param {boolean} shouldCreateObservable
   * @return {any}
   */
  getObservable(name: string, shouldCreateObservable: boolean = false) {
    if (!this.subscribeList.has(name)) {
      if (shouldCreateObservable) {
        this.registerObservable(name);
      } else {
        return null;
      }
    }
    return this.subscribeList.get(name);
  }


  isNonConfigurationBindings(config) {
    const segBindings = config.segmentAnnotationBindings.filter(segBinding => !segBinding.hasOwnProperty('responseUsed'));
    if (segBindings.length > 0) {
      return true;
    }
    return false;
  }


  public getSegmentsBasedOnCondition(config:any): Observable<any> {
    let priority: number = 1;
    const segBindings = cloneDeep(config.segmentAnnotationBindings.filter(segBinding => segBinding.hasOwnProperty('responseUsed') && segBinding.responseUsed === 'Configuration'));
    const segBinding:IdataBinding = maxBy(segBindings, function(o) {
      return o.priority;
    });
    if (this.cached.has(segBinding.queryString)) {
      const configId = this.cached.get(segBinding.queryString);
      this._configurationStoreHandler.getConfigById('SegmentDefinition', configId).take(1).subscribe(d=>console.log(d));
      return this._configurationStoreHandler.getConfigById('SegmentDefinition', configId).take(1);
    }
    else {
      // Directly sending the top priority binding as recursive databinding response
      // not working as expected .
      segBinding.queryString = this._agregatorService.interpolateWithCurrentInstance(segBinding.queryString);
      return this.fetchDataBasedOnPriority(segBindings, segBinding.priority, {});
    }
    /*if(segBinding.priority > 1) {
    // TODO here  need to check for cache all cancer types when more than crc is there
        return this.fetchDataBasedOnPriority(segBindings, priority, {});
    }
    else if (this.cached.has(segBinding.queryString)) {
      const configName = this.cached.get(segBinding.queryString);
      return this._configurationStoreHandler.getConfigByName('Segmentdefinition', configName).take(1);
    }
    else {
      return this.fetchDataBasedOnPriority(segBindings, priority, {});
    }*/

  }

  fetchDataBasedOnPriority(completeBindings, priority, finalInterpolateObj = { }): Observable<any> {
    const currentBindings = completeBindings.filter(binding => {
      if (binding.priority === priority) {
        return true;
      }
    });
    if (currentBindings[0].params) {
    const cancerType = this._agregatorService.interpolateWithCurrentInstance(currentBindings[0].params.cancerType);
    const organization = this._agregatorService.interpolateWithCurrentInstance(currentBindings[0].params.organization);
    const params = {
        "type": currentBindings[0].params.type,
        "cancerType": cancerType,
        "organization": organization,
        "resourceType": "SegmentDefinition",
        "application": this._navigationConfigService.getCurrentApplicationId()
    }
      const paramsKey = JSON.stringify(params);
      const configId = this.cached.get(paramsKey);
      if (configId) {
        return this._configurationStoreHandler.getConfigById('SegmentDefinition', configId).take(1).map(segment => segment);
      } else {
        const req = this._ispmHttpClient.get('layout/config', params).pipe(
            take(1),
            tap((config) => {
          this._configurationStoreHandler.setConfiguration(config['resource']);
          this.cached.set(paramsKey, config['resource'].id);
        })).map(res => {
          if (res && res['resource']) {
            return res['resource'];
          } else {
            this.showErrorMessagePopup('Segment Configuration Not Defined',
              'There are no proper segment configuration found. Please ask your administrator to add a default segment configuration.',
              'ALERT',
              '');
          }
        }).publish();
        req.connect();
        return req;
      }
    } else {
      return this._agregatorService.registerQuery(currentBindings).take(1)
        .switchMap(primaryData => {
          finalInterpolateObj = Object.assign(finalInterpolateObj, ...primaryData);
          priority++;
          const nextBindings = completeBindings.filter(binding => (binding.priority === priority));
          if (!isEmpty(nextBindings)) {
            nextBindings.forEach(nextBinding => {
              nextBinding.queryString = this._agregatorService.interpolate(nextBinding.queryString, finalInterpolateObj);
              nextBinding.interpolatedQuery = nextBinding.queryString;
              completeBindings[completeBindings.findIndex(binding => nextBinding.identifier === binding.identifier)].queryString = nextBinding.queryString;
            });
            this._agregatorService.setPolatedDatabindings(nextBindings);
            return this.fetchDataBasedOnPriority(completeBindings, priority, finalInterpolateObj);
          } else {
            priority = 0;
            completeBindings = null;
            const segmentDef = this.getValueBasedOnIdentifier(currentBindings, finalInterpolateObj);
            if (segmentDef) {
              this._configurationStoreHandler.setConfiguration(segmentDef);
              this.cached.set(currentBindings[0].queryString, segmentDef.id);
            }
            return Observable.of(segmentDef);
          }
        });
    }
    }

  public showErrorMessagePopup(title, message, modalType, nextState) {
    this._modalLoader.popupModal('confirm',
      ConfirmModalLoaderPayload.builder().
      setTitle(title).
      setContent(message)
        .setApproveButtonText('OK'),
      modalType ? modalType : 'ALERT'
    ).subscribe(() => {
      this._router.navigate(nextState ? nextState : '');
    });
  }

  getValueBasedOnIdentifier(dataBinding, responseValue): any {
    let value = '';
    dataBinding.forEach(binding => {

      if (responseValue.hasOwnProperty(binding.identifier)) {
        value = get(responseValue, binding.identifier);
      }});
    return value;
  }

  public getSvgContent(): Observable<string> {
    if (this.imageContent.has(this.segmentDef.segmentFiles[0])) {
      return this.imageContent.get(this.segmentDef.segmentFiles[0]);
    }
    else {
    const svgRes$ =
        this.http.get(`${this.imgDirectoryPath}${this.segmentDef.segmentFiles[0]}`, {
          headers: {
            'Accept': 'text/svg',
            'Cache-Control' : 'public, max-age=3600'
          }, responseType : 'text'
        }).pipe(
          retry(2),
          map(data => {
          return data;
        }),
         share(),
          catchError(err => {
            console.error('Segment Content could not be fetched for' ,this.segmentDef.segmentFiles[0])
             return EMPTY;
          }));
      svgRes$.publish().connect();
      this.imageContent.set(this.segmentDef.segmentFiles[0], svgRes$);
      return svgRes$
    }
  }

  public getAnnotationDataForSegments(segmentAnnotationBinding: SegmentAnnotationBindings[]): Observable<any> {
    if (!isEmpty(segmentAnnotationBinding)) {
      const formId = this.getAnnotatorUniqueIdentifier();
      let currentData;

      const dataBindings: Array<IdataBinding> = [];
      const segBindings = segmentAnnotationBinding.filter(segBinding => !segBinding.hasOwnProperty('responseUsed'));
      if (!isEmpty(segBindings)) {
        segBindings.forEach(segbinding => {
            dataBindings.push({
              'identifier': get(segbinding, 'identifier'),
              'queryString': get(segbinding, 'queryString'),
              'identifierType': get(segbinding, 'identifierType'),
              'isDepandant': get(segbinding, 'isDepandant'),
              'pickFromPath': get(segbinding, 'pickFromPath'),
              'subResourceType': get(segbinding, 'subResourceType'),
              'retrigger': get(segbinding, 'retrigger'),
              'targetResource': get(segbinding, 'targetResource'),
            });
          }
        );
        this._agregatorService.registerQuery(cloneDeep(dataBindings),formId);
        const interpolateAndfetch = lodashFilter(dataBindings, function(o) {
           return  (o.hasOwnProperty('isDepandant') && (o.isDepandant === true)); });
        const actualPrefetch = differenceWith(dataBindings, interpolateAndfetch, isEqual);

        return this._agregatorService.registerQuery(actualPrefetch).
        filter(parentdata =>
          this.retriggerDataIdentifierAvailable(actualPrefetch) || !(isEqual(parentdata, currentData)))
          .switchMap(data => {
          currentData = data;
          return this.interpolateAndRegister(actualPrefetch, interpolateAndfetch, data, formId);
        });
      }
    }
 }


  private interpolateAndRegister(_feederDataBinding: Array<IdataBinding>, _depandantDatabindings: Array<IdataBinding>,
    _interpolateObj: any, formId: string) {
    const formData = Object.assign({ },this._agregatorService.getPatientContextId(), ..._interpolateObj);
    _depandantDatabindings.map(databinding => {
      databinding.queryString = this._agregatorService.interpolate(databinding.queryString, formData);
      databinding.interpolatedQuery = databinding.queryString;
    });
    this._agregatorService.setPolatedDatabindings(_depandantDatabindings);
      return this._agregatorService.registerQuery(_depandantDatabindings).filter(val => !isEmpty(val))
        .map(val => val);
  }

    //Currently not in use as retriggeer of dependant is happening via aggregator locally
  private retriggerDepandant(_feederDatabindings: Array<IdataBinding>, _depandantDatabindings: Array<IdataBinding>, formId: string) {
    const retrigerDepandants = this._agregatorService.getretriggerDatabindings();
    if (retrigerDepandants.inArray(function (e) {
        return e.identifier === _feederDatabindings[0].identifier;
      })) {
      remove(retrigerDepandants, function (binding) {
        return binding.identifier === _feederDatabindings[0].identifier;
      });
      this._agregatorService.setretriggerDatabindings(retrigerDepandants);
      return this._agregatorService.ondemandRegister(_depandantDatabindings, true).filter(val => !isEmpty(val))
        .map(val => val);
    }
    else {
      return this._agregatorService.ondemandRegister(_depandantDatabindings).filter(val => !isEmpty(val))
        .map(val => val);
    }

  }

  retriggerDataIdentifierAvailable(_feederDatabindings: Array<IdataBinding>) {
    const retrigerDepandants = this._agregatorService.getretriggerDatabindings();
    if (retrigerDepandants.inArray(function (e) {
        return e.identifier === _feederDatabindings[0].identifier;
      })) {
      return true;
    }
    return false;
  }


  getAnnotatorUniqueIdentifier() {
       const identifierConstant = 'ANNOTATOR';
       return `${identifierConstant}_${StringUtils.generateGuid()}`;
     }

  /**
   * Dismiss observable and remove it from subscribe list
   * @param name
   * */
  dismissObservable(name: string) {
    if (!this.subscribeList.has(name)) { return; }
    const observable = this.subscribeList.get(name);

    if (observable) {
      this.subscribeList.delete(name);
      observable.complete();
    }

  }
  }


